export enum LetterDeliveryToRoleEnum {
  PATIENT           = '00000250-1000-0000-0000-000000000001',
  REFERRING_DOCTOR  = '00000250-1000-0000-0000-000000000002',
  GENERAL_DOCTOR    = '00000250-1000-0000-0000-000000000003',
  DOCTOR            = '00000250-1000-0000-0000-000000000004',
  OTHER             = '00000250-1000-0000-0000-000000000005',
}
